import OBJECT_TYPES from '../../models/objectTypes.js';
import _ from 'lodash';

class UploadSettingsController {
  constructor(uploadSettingsService, localStorageService) {
    this.uploadSettingsService = uploadSettingsService;
    this.localStorageService = localStorageService;
    this.thresholdUpdated = false;
    this.fields = OBJECT_TYPES;
    this.hideReplaceModeToggles = ['deltaDemographics', 'deltaResources', 'deltaClassResources', 'deltaCourseResources'];
    this.getUploadSettings();
    this.hasCustomerInfo = this.localStorageService.get('impersonatingCustomer');
  }

  isFormFieldErroneous(settingForm, field) {
    return settingForm[field].$error;
  }

  isFieldExceedingRange(settingForm, field) {
    return settingForm[field].$error.max || settingForm[field].$error.min;
  }

  isFieldInvalid(settingForm, field) {
    return settingForm[field].$error.number;
  }

  getUploadSettings() {
    this.uploadSettingsService.getImportSettings().then(
      this.onGetUploadSettingsSuccess.bind(this),
      this.onUploadSettingsFailure.bind(this)
    );
  }

  onGetUploadSettingsSuccess(response) {
    const uploadSettings = response.data.content;
    this.uploadSettings = _.map(uploadSettings, (item) => {
      return {
        threshold: item.threshold,
        objectTypeId: item.objectTypeId,
        name: item.objectType.name,
        format: item.format,
        active: item.active,
        paginationValue: item.paginationValue,
        importToBeDeleted: item.importToBeDeleted || false,
        replaceModeEnabled: item.replaceModeEnabled || false
      };
    });

    //filter the fields not applicaiable to oneRosterApi
    if (!this.isOneRosterApi) {
      this.fields = _.reject(this.fields, {
        isOneRosterApi: true
      });
    }

    //add content to fields object 
    this.fields.forEach((item) => {
      var data = _.find(this.uploadSettings, {
        'name': item.name
      });
      item.threshold = data.threshold;
      item.objectTypeId = data.objectTypeId;
      item.active = data.active;
      item.paginationValue = data.paginationValue;
      item.importToBeDeleted = data.importToBeDeleted;
      item.replaceModeEnabled = data.replaceModeEnabled;
    });
  }

  onUploadSettingsFailure() {
    console.log('There was an error retrieving your upload setting configuration.');
  }

  update(formData) {
    if (formData.$valid) {
      const uploadSettings = _.map(this.fields, (item) => _.pick(item, ['threshold', 'objectTypeId', 'active', 'paginationValue', 'importToBeDeleted', 'replaceModeEnabled']));
      this.uploadSettingsService.updateImportSettings(uploadSettings).then(
        this.onUpdateUploadSettingsSuccess.bind(this),
        this.onUploadSettingsFailure.bind(this)
      );
    }
  }

  onUpdateUploadSettingsSuccess() {
    this.thresholdUpdated = true;
  }

}

UploadSettingsController.$inject = ['uploadSettingsService', 'localStorageService'];

export default UploadSettingsController;


// WEBPACK FOOTER //
// ./app/components/uploadSettings/uploadSettings.controller.js